module.exports = __webpack_public_path__ + "img/spin_btn.d1c835a1.png";